import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '@/lib/analytics';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === 'unset') setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent('granted');
    setVisible(false);
  };
  const decline = () => {
    setConsent('denied');
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-3 bottom-3 z-50 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-md"
    >
      <div className="card p-4 shadow-2xl shadow-black/40 backdrop-blur-md">
        <p className="text-sm font-medium text-fg-base">Cookie preferences</p>
        <p className="mt-2 text-sm text-fg-muted">
          We use a single cookie to keep you signed into the admin area.
          With your permission, we'd also like to use Google Ads tracking
          to measure which ads bring people to the site. You can change
          your mind any time. See our{' '}
          <Link to="/privacy" className="link">
            privacy notice
          </Link>
          .
        </p>
        <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button type="button" className="btn-ghost" onClick={decline}>
            Decline
          </button>
          <button type="button" className="btn-primary" onClick={accept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
